import React from 'react';
import { FuelButton } from '@frete.com/fuel-react';
import { FuelFlex } from '@frete.com/fuel-station-react';
import useAmplitude from '@hooks/useAmplitude';

import { ProposalPendingInterface } from '@interface/proposals';
import { useNavigate } from 'react-router-dom';
import * as Styled from './ActionsStyles';

interface ActionsPropsInterface {
  innerRef?: React.RefObject<HTMLDivElement>;
  proposalId: ProposalPendingInterface['id'];
  createdBy: string;
}

function Actions({ innerRef, proposalId, createdBy }: ActionsPropsInterface) {
  const { amplitudeEvent } = useAmplitude();

  const navigate = useNavigate();

  if (createdBy !== 'trucker:deposit:fee') {
    return null;
  }
  function handleClickConfirm(id: ActionsPropsInterface['proposalId']) {
    amplitudeEvent('proposal_drawer_clicked_button', {
      source: 'button-confirmar',
    });

    navigate(`pre-viagem/${id}/aceite`);
  }

  function handleClickRejected(id: ActionsPropsInterface['proposalId']) {
    amplitudeEvent('proposal_drawer_clicked_button', {
      source: 'button-descartar',
    });

    navigate(`pre-viagem/${id}/recusa`);
  }

  return (
    <Styled.Wrapper ref={innerRef}>
      <FuelFlex
        defaultProps={{
          alignItems: 'center',
          gap: 'km3',
          justifyContent: 'space-between',
        }}
      >
        <FuelButton
          data-testid="button-cancel"
          variant="tertiary"
          size="large"
          type="button"
          fullWidth
          onClick={() => handleClickRejected(proposalId)}
        >
          Cancelar
        </FuelButton>
        <FuelButton
          data-testid="button-done"
          size="large"
          type="submit"
          fullWidth
          onClick={() => handleClickConfirm(proposalId)}
        >
          Confirmar viagem
        </FuelButton>
      </FuelFlex>
    </Styled.Wrapper>
  );
}

export default Actions;
